<label [for]="name">{{ label }}</label>
<div class="select">
	<select [id]="name" [formControl]="control">
		<option *ngFor="let item of options" [ngValue]="item.id">
			{{ item.name }}
		</option>
	</select>
	<mat-icon>arrow_drop_down</mat-icon>
</div>
